import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "question-detail-container"
};
const _hoisted_2 = {
  class: "blanks-text-container"
};
const _hoisted_3 = {
  class: "blanks-text"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 0,
  class: "blank-correction text-blank-input-correction"
};
const _hoisted_6 = {
  class: "answer-image-preview-container"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "answer-image-preview-container"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_quiz_question_label = _resolveComponent("quiz-question-label");
  const _component_w_input = _resolveComponent("w-input");
  const _component_w_select = _resolveComponent("w-select");
  const _component_w_html_tool_tip = _resolveComponent("w-html-tool-tip");
  const _component_quiz_answers_validation_alert = _resolveComponent("quiz-answers-validation-alert");
  const _component_quiz_question_correction_explanation = _resolveComponent("quiz-question-correction-explanation");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['quiz-blanks-question-container', {
      'result-mode': _ctx.isResultMode
    }])
  }, [_ctx.displayOverallVerdictIcon ? (_openBlock(), _createBlock(_component_icon, {
    key: 0,
    icon: _ctx.overallAnswersVerdictIcon,
    class: _normalizeClass(['question-overall-verdict-icon', _ctx.overallVerdictIconClass])
  }, null, 8, ["icon", "class"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_quiz_question_label, {
    label: _ctx.questionCustomLabel || _ctx.question.label,
    "label-detail": _ctx.question?.information
  }, null, 8, ["label", "label-detail"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedBlanksText, (segment, index) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: index
    }, [segment.type === 'text' ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "text",
      innerHTML: segment.content?.replace(/\n+/g, '<br>')
    }, null, 8, _hoisted_4)) : segment?.blank && segment.type === 'blank' && segment.blank.type === _ctx.BlankType.TEXT ? (_openBlock(), _createElementBlock("span", {
      key: 1,
      class: _normalizeClass(['text-blank-container', _ctx.answerStatusClass(segment.blank)])
    }, [_createElementVNode("span", {
      class: _normalizeClass(['text-blank-input', {
        'cut-right': _ctx.shouldDisplayTextBlankCorrection(segment.blank)
      }])
    }, [_createVNode(_component_w_input, {
      value: _ctx.getUserTextBlankAnswer(segment.blank.id),
      type: "text",
      "auto-resize": _ctx.isResultMode,
      "auto-resize-additional-gap": 30,
      maxlength: _ctx.LABEL_NB_MAX_CHARS,
      onInput: event => _ctx.onTextBlankAnswerUpdate(segment.blank.id, event)
    }, null, 8, ["value", "auto-resize", "maxlength", "onInput"]), _ctx.isResultMode ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      class: _normalizeClass(['answer-status-icon', _ctx.answerStatusClass(segment.blank)]),
      icon: _ctx.answerStatusIcon(segment.blank)
    }, null, 8, ["class", "icon"])) : _createCommentVNode("", true)], 2), _ctx.shouldDisplayTextBlankCorrection(segment.blank) ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getTextBlankAnswers(segment.blank)), 1)) : _createCommentVNode("", true)], 2)) : segment?.blank && segment.type === 'blank' && segment.blank.type === _ctx.BlankType.MULTI_SELECT ? (_openBlock(), _createElementBlock("span", {
      key: 2,
      class: _normalizeClass(['select-blank-container', _ctx.answerStatusClass(segment.blank)])
    }, [_createElementVNode("span", {
      class: _normalizeClass(['blank-select', {
        'cut-right': _ctx.shouldDisplaySelectBlankCorrection(segment.blank)
      }])
    }, [_createVNode(_component_w_html_tool_tip, {
      placement: "top",
      "hide-after": 100,
      disabled: !_ctx.getUserBlankAnswerImage(segment.blank),
      "show-arrow": false,
      popperClass: "quiz-answer-image-select-preview-popper"
    }, _createSlots({
      default: _withCtx(() => [_createVNode(_component_w_select, {
        value: _ctx.getUserMultiSelectBlankAnswer(segment.blank.id),
        options: _ctx.getMultiSelectBlankOptions(segment.blank),
        placeholder: _ctx.$t('view.speach.quiz.question.fillInTheBlanks.selectBlank.placeholder'),
        "popper-class": "blank-select-popper",
        "auto-resize": _ctx.isResultMode,
        "auto-resize-additional-gap": 30,
        clearable: true,
        enabled: !_ctx.isResultMode,
        onChange: event => _ctx.onMultiSelectBlankAnswerUpdate(segment.blank, event)
      }, null, 8, ["value", "options", "placeholder", "auto-resize", "enabled", "onChange"])]),
      _: 2
    }, [_ctx.getUserBlankAnswerImage(segment.blank) ? {
      name: "content",
      fn: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        src: _ctx.getUserBlankAnswerImagePath(segment.blank),
        class: "answer-image-preview"
      }, null, 8, _hoisted_7)])]),
      key: "0"
    } : undefined]), 1032, ["disabled"]), _ctx.isResultMode ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      class: _normalizeClass(['answer-status-icon', _ctx.answerStatusClass(segment.blank)]),
      icon: _ctx.answerStatusIcon(segment.blank)
    }, null, 8, ["class", "icon"])) : _createCommentVNode("", true)], 2), _ctx.shouldDisplaySelectBlankCorrection(segment.blank) ? (_openBlock(), _createBlock(_component_w_html_tool_tip, {
      key: 0,
      placement: "top",
      "hide-after": 100,
      disabled: !_ctx.getBlankCorrectAnswer(segment.blank)?.image,
      "show-arrow": false,
      popperClass: "quiz-answer-image-select-preview-popper"
    }, _createSlots({
      default: _withCtx(() => [_createElementVNode("div", {
        class: "blank-correction blank-select-correction",
        innerHTML: _ctx.getBlankCorrectAnswerValue(segment.blank)
      }, null, 8, _hoisted_10)]),
      _: 2
    }, [_ctx.getBlankCorrectAnswer(segment.blank)?.image ? {
      name: "content",
      fn: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        src: _ctx.getBlankCorrectAnswerImagePath(segment.blank),
        class: "answer-image-preview"
      }, null, 8, _hoisted_9)])]),
      key: "0"
    } : undefined]), 1032, ["disabled"])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 64);
  }), 128))])]), _ctx.displayAnswersValidationAlert ? (_openBlock(), _createBlock(_component_quiz_answers_validation_alert, {
    key: 0,
    question: _ctx.question,
    class: "answers-validation-block",
    "answers-validation-state": _ctx.answersValidationState
  }, null, 8, ["question", "answers-validation-state"])) : _createCommentVNode("", true), _ctx.isResultMode && _ctx.question.correction ? (_openBlock(), _createBlock(_component_quiz_question_correction_explanation, {
    key: 1,
    class: "correction-explanation-block",
    "question-correction": _ctx.question.correction
  }, null, 8, ["question-correction"])) : _createCommentVNode("", true)])], 2);
}